export default __webpack_public_path__ + "static/media/disconnected.51af6962.wav";